import React, { useState } from "react";
import { DefaultModalForm, useModalDispatch } from "collections/Modal";
import { useTranslation } from "utilities/i18n";
import { useCreateTrialSubscriptionMutation } from "generated/graphql";
import { CancelButton, DetailsLoader, SubmitButton } from "elements";
import "./StartTrialModal.scss";

export const StartTrialModal: React.FC<{
  refresh: () => void;
}> = ({ refresh }) => {
  const { t } = useTranslation();
  const closeModal = useModalDispatch();

  const [, createTrial] = useCreateTrialSubscriptionMutation();
  const [modalMessage, setModalMessage] = useState(
    t("CLARITI_TRIAL_CONFIRM_DIALOG")
  );

  const eulaAcceptanceMessage = t("CLARITI_TRIAL_EULA_ACCEPT");
  const confDurationAndParticipantLimit = t(
    "CLARITI_TRIAL_CONF_DUR_PART_LIMIT"
  );
  const reviewEulaMessage = t("CLARITI_TRIAL_REVIEW_EULA");

  const onSubmit = async () => {
    const createTrialResponse = await createTrial();

    if (createTrialResponse.error) {
      setModalMessage(t("START_TRIAL_ERROR"));
    }

    if (createTrialResponse.data?.createTrialSubscription) {
      refresh();
      closeModal();
    }
  };

  return (
    <DefaultModalForm
      title={t("CLARITI_TRIAL")}
      onSubmit={onSubmit}
      name="StartTrialModal"
      className="fixed-lg full-max-height start-trial-modal"
      closeIcon={true}
      fluid={false}
    >
      {({ isSubmitting }) => (
        <>
          <div className="form-content">
            <DetailsLoader
              loading={modalMessage === ""}
              title={t("CREATING_TRIAL_SUBSCRIPTION")}
            >
              <p>
                <strong>{confDurationAndParticipantLimit}</strong>
              </p>
              <p>{reviewEulaMessage}</p>
              <textarea
                className="form-control no-resize rows-15"
                readOnly={true}
                value={t("CLARITI_TRIAL_EULA", { ns: "claritiTrialEula" })}
              ></textarea>
              <p className="mt-1">{eulaAcceptanceMessage}</p>
              <p>{modalMessage}</p>
            </DetailsLoader>
          </div>
          <div className="btn-container">
            <CancelButton onClick={closeModal}>{t("DECLINE")}</CancelButton>
            <SubmitButton
              disabled={isSubmitting}
              isSubmitting={isSubmitting}
              labelKey="I_ACCEPT"
              submittingLabelKey="I_ACCEPT"
            />
          </div>
        </>
      )}
    </DefaultModalForm>
  );
};
